import { message } from "antd";
import CommonUtil from "./CommonUtils";
import { formatInTimeZone, toZonedTime } from "date-fns-tz";
import packageJson from "../../package.json";
import {
  getLastPunch,
  getServerUtcTime,
} from "../services/FunctionKeysService";
import departmentImg from "../assets/images/departmenImage.png";
import waveMeal from "../assets/images/waveMeal.png";
import breakEnd from "../assets/latestImages/break_end.png";
import breakStart from "../assets/latestImages/break_start.png";
import clockIn from "../assets/latestImages/clock_in.png";
import clockOut from "../assets/latestImages/clock_out.png";
import mealEnd from "../assets/latestImages/meal_end.png";
import mealStart from "../assets/latestImages/meal_start.png";
import accrualBalance from "../assets/images/accural_balence.svg";
import clockIn3 from "../assets/images/clock_in_3.png";
import onlineSchedule from "../assets/images/online_schedule.png";
import punchInfo from "../assets/images/punch_info.png";
import AppConstant from "./AppConstant";
import { getCurrentLocale } from "../i18n/languageService";
const {
  format,
  parse,
  addMinutes,
  subMinutes,
  isWithinInterval,
  differenceInMinutes,
  isBefore,
  isAfter,
  isValid,
  parseISO,
} = require("date-fns");

/**
 * @author vikash kumar
 * This method return shiftId
 * If user under the shift then retun that shiftId
 * If user not under the shift then retun null value
 */
export const isUserUnderShift = (
  employeeShiftData,
  attendanceRule,
  punchTime
) => {
  const shiftStartGracePeriod = attendanceRule?.shiftStartGracePeriod
    ? attendanceRule.shiftStartGracePeriod
    : 0;
  const shiftEndGracePeriod = attendanceRule?.shiftEndGracePeriod
    ? attendanceRule.shiftEndGracePeriod
    : 0;

  const dateFormat = "MM/dd/yyyy HH:mm";

  // Convert punchTime to Date object
  const punchDateTime = new Date(punchTime);

  if (!employeeShiftData || employeeShiftData.length === 0) {
    return {
      isEmployeeUnderShift: false,
      shiftData: null,
    };
  }

  let nearestShift = null;
  let nearestShiftDiff = Infinity;

  for (let i = 0; i < employeeShiftData.length; i++) {
    const { shiftId, startTime, endTime, shiftDate } = employeeShiftData[i];
    const nextShift = employeeShiftData[i + 1];

    // Convert String type shiftDate and times to Date objects
    const shiftStartTime = parse(
      `${shiftDate} ${startTime}`,
      dateFormat,
      new Date()
    );
    const shiftEndTime = parse(
      `${shiftDate} ${endTime}`,
      dateFormat,
      new Date()
    );

    // Calculate shift start and end time with grace periods
    const shiftStartTimeWithGracePeriod = subMinutes(
      shiftStartTime,
      shiftStartGracePeriod
    );
    const shiftEndTimeWithGracePeriod = addMinutes(
      shiftEndTime,
      shiftEndGracePeriod
    );

    // Check if punch time is within the current shift's allowed range
    if (
      isWithinInterval(punchDateTime, {
        start: shiftStartTimeWithGracePeriod,
        end: shiftEndTimeWithGracePeriod,
      })
    ) {
      return {
        isEmployeeUnderShift: true,
        shiftData: {
          shiftId,
          startTime,
          endTime,
          shiftDate,
        },
      };
    }

    // Calculate the difference between the punch time and the shift start time
    const diffToShiftStart = Math.abs(
      differenceInMinutes(punchDateTime, shiftStartTime)
    );
    if (diffToShiftStart < nearestShiftDiff) {
      nearestShift = {
        shiftId,
        startTime,
        endTime,
        shiftDate,
      };
      nearestShiftDiff = diffToShiftStart;
    }

    // Check if there is a next shift and handle gaps or overlaps
    if (nextShift) {
      const nextShiftStartTime = parse(
        `${nextShift.shiftDate} ${nextShift.startTime}`,
        dateFormat,
        new Date()
      );
      const nextShiftEndTime = parse(
        `${nextShift.shiftDate} ${nextShift.endTime}`,
        dateFormat,
        new Date()
      );

      // Calculate the beginning of the next shift with grace period
      const nextShiftStartTimeWithGracePeriod = subMinutes(
        nextShiftStartTime,
        shiftStartGracePeriod
      );
      const nextShiftEndTimeWithGracePeriod = addMinutes(
        nextShiftEndTime,
        shiftEndGracePeriod
      );

      // Check if punch time is within the next shift's allowed range
      if (
        isWithinInterval(punchDateTime, {
          start: nextShiftStartTimeWithGracePeriod,
          end: nextShiftEndTimeWithGracePeriod,
        })
      ) {
        return {
          isEmployeeUnderShift: true,
          shiftData: {
            shiftId: nextShift.shiftId,
            startTime: nextShift.startTime,
            endTime: nextShift.endTime,
            shiftDate: nextShift.shiftDate,
          },
        };
      }

      // Calculate the difference between the punch time and the next shift start time
      const diffToNextShiftStart = Math.abs(
        differenceInMinutes(punchDateTime, nextShiftStartTime)
      );
      if (diffToNextShiftStart < nearestShiftDiff) {
        nearestShift = {
          shiftId: nextShift.shiftId,
          startTime: nextShift.startTime,
          endTime: nextShift.endTime,
          shiftDate: nextShift.shiftDate,
        };
        nearestShiftDiff = diffToNextShiftStart;
      }
    }
  }
  return {
    isEmployeeUnderShift: false,
    shiftData: nearestShift,
  };
};

export const isUserUnderShiftEndOrStartWithGracePeriod = (
  punchTime,
  shiftDate,
  shiftTime,
  attendanceRule
) => {
  const gracePeriod = attendanceRule?.shiftStartGracePeriod
    ? attendanceRule.shiftStartGracePeriod
    : 0;
  // Define date format
  const dateFormat = "MM/dd/yyyy HH:mm";
  // Convert punchTime to Date object
  const punchDateTime = new Date(punchTime);
  const shiftStartEndTime = parse(
    `${shiftDate} ${shiftTime}`,
    dateFormat,
    new Date()
  );

  const shiftTimeWithAdditionOfGraceTime = addMinutes(
    shiftStartEndTime,
    gracePeriod
  );
  const shiftTimeWithSubtractionOfGraceTime = subMinutes(
    shiftStartEndTime,
    gracePeriod
  );

  if (
    isWithinInterval(punchDateTime, {
      start: shiftTimeWithSubtractionOfGraceTime,
      end: shiftTimeWithAdditionOfGraceTime,
    })
  ) {
    return true;
  }
  return false;
};

/**
 * If pass the key clock_in then it will check erly clock_in
 * If pass the key clock_out then it will check erly clock_out
 */
export const isUserEarlyClockIn_ClockOut = (
  menuObj,
  punchTime,
  shiftInfo,
  attendanceRule,
  key
) => {
  const { startTime, endTime, shiftDate } = shiftInfo;
  const gracePeriod = attendanceRule?.shiftStartGracePeriod || 0;

  const dateFormat = "MM/dd/yyyy HH:mm";
  const punchDateTime = new Date(punchTime);

  // Parse shift start and end times
  const shiftStartTime = parse(
    `${shiftDate} ${startTime}`,
    dateFormat,
    new Date()
  );
  const shiftEndTime = parse(`${shiftDate} ${endTime}`, dateFormat, new Date());

  // Adjust times with grace period
  const shiftStartWithGrace = subMinutes(shiftStartTime, gracePeriod);
  const shiftEndWithGrace = subMinutes(shiftEndTime, gracePeriod);

  // Check for early clock-in or clock-out
  if (key === "clock_in") {
    return (
      isBefore(punchDateTime, shiftStartWithGrace) &&
      menuObj.eventCode === "0" &&
      attendanceRule.shiftEarlyStartAttProfile !== 0
    );
  } else if (key === "clock_out") {
    return (
      isBefore(punchDateTime, shiftEndWithGrace) &&
      menuObj.eventCode === "1" &&
      attendanceRule.shiftEarlyEndAttProfile !== 0
    );
  }
  return false;
};

export const isUserLateClockIn = (
  menuObj,
  punchTime,
  shiftData,
  attendanceRule
) => {
  const { startTime, shiftDate } = shiftData;
  const gracePeriod = attendanceRule?.shiftStartGracePeriod
    ? attendanceRule.shiftStartGracePeriod
    : 0;
  const dateFormat = "MM/dd/yyyy HH:mm";
  const punchDateTime = new Date(punchTime);
  const shiftStartTime = parse(
    `${shiftDate} ${startTime}`,
    dateFormat,
    new Date()
  );
  const shiftTimeWithGraceTime = addMinutes(shiftStartTime, gracePeriod);
  // Check for late clock-in also need to check event code
  if (
    isAfter(punchDateTime, shiftTimeWithGraceTime) &&
    menuObj.eventCode === "0" &&
    attendanceRule.shiftLateStartAttProfile !== 0
  ) {
    return true;
  }
  return false;
};

export const isUserLateClockOut = (
  menuObj,
  punchTime,
  shiftData,
  attendanceRule
) => {
  const { endTime, shiftDate } = shiftData;
  const gracePeriod = attendanceRule?.shiftEndGracePeriod
    ? attendanceRule.shiftEndGracePeriod
    : 0;
  const dateFormat = "MM/dd/yyyy HH:mm";
  const punchDateTime = new Date(punchTime);
  const shiftEndTime = parse(`${shiftDate} ${endTime}`, dateFormat, new Date());

  const shiftTimeWithGraceTime = addMinutes(shiftEndTime, gracePeriod);
  if (
    isAfter(punchDateTime, shiftTimeWithGraceTime) &&
    menuObj.eventCode === "1" &&
    attendanceRule.shiftLateEndAttProfile !== 0
  ) {
    return true;
  }
  return false;
};

/**
 * Updates one or all objects in an array immutably.
 * @param {Array<Object>} array - Source array.
 * @param {Object} fields - Fields to merge into the object(s).
 * @param {number|string} [indexOrAll=0] - Target index or 'all' for every object.
 * @returns {Array<Object>} New array with updated object(s).
 */
export const updateObjectInArray = (
  array, fields, indexOrAll = 0
) => {
  
  if(!Array.isArray(array)){
    console.error("updateObjectInArray: first argument must be an array");
    return [];
  }

  if( typeof fields !=="object" || fields === null){
    console.error("updateObjectInArray: fields must be a non-null object");
    return [...array]; 
  }

  if (indexOrAll === "all") {
    return array.map((item) => ({ ...item, ...fields }));
  }

  if (typeof indexOrAll !== "number" || indexOrAll < 0 || indexOrAll >= array.length) {
    console.error("updateObjectInArray: invalid index", indexOrAll);
    return [...array];
  }
  
  return array.map((item, i) =>
    i === indexOrAll ? { ...item, ...fields } : item
  );

};

/**
 * Displays a message based on the type provided.
 * @param {string} type - The type of message (e.g., "success", "error", "info").
 * @param {string} content - The content of the message to be displayed.
 */
export const showMessage = (type, content) => {
  switch (type) {
    case "success":
      message.success({ content });
      break;
    case "error":
      message.error({ content });
      break;
    case "info":
      message.info({ content });
      break;
    default:
      message.success({ content });
  }
};

/**
 * @param {string}  | removed the logged in data from local storage
 */
export const removeLoggedInData = () => {
  [
    "persist:root",
    "customMappingData",
    "laborCodeData",
    "employeeNumber",
    "employeeName",
    "laborCodeData",
    "isLoggedIn",
  ].forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem("prompt_shown");
};

/**
 *
 * @description Array of keys to be removed from local storage
 */
export const clearLocalStorage = (keys = []) => {
  keys.forEach((key) => localStorage.removeItem(key));
};

/**
 * Segregate the valid parent and child type labor code and stored the respective indexes in result array
 *
 * Generates an ordered list of indices for labor codes, based on that indices display the labor code.
 *@param {Array} data - Array of labor code objects.
 * @returns {Array} Ordered indices for displaying labor codes.
 */
export const getResultIndexWithParentChildAssociation = (data) => {
  const result = [];
  const parentMap = new Map();

  data.forEach((item, index) => {
    const masterDetails = item.masterOrgCodeDetails;
    const { type, parentCodeType } = masterDetails;
    let isChildWithParent = false;

    // Check if the item is a child with a valid parent
    if (parentCodeType && parentMap.has(parentCodeType)) {
      isChildWithParent = true;
      result.push(index);
    }

    // Add the item as a parent if it's acting as one
    if (!parentCodeType || parentCodeType.trim() === "" || isChildWithParent) {
      parentMap.set(type, index);
      if (!isChildWithParent) {
        result.push(index);
      }
    }
  });
  return result;
};

/**
 * Detects the browser name based on the user agent string.
 *
 * @returns {string} The name of the browser (e.g., 'Chrome', 'Firefox', 'Safari', 'Edge', 'Opera', 'Internet Explorer', or 'Unknown Browser').
 */
export const getBrowserName = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("edg")) {
    return "Edge";
  } else if (userAgent.includes("opr") || userAgent.includes("opera")) {
    return "Opera";
  } else if (
    userAgent.includes("chrome") &&
    !userAgent.includes("edge") &&
    !userAgent.includes("opr")
  ) {
    return "Chrome";
  } else if (userAgent.includes("firefox")) {
    return "Firefox";
  } else if (
    userAgent.includes("safari") &&
    !userAgent.includes("chrome") &&
    !userAgent.includes("edg")
  ) {
    return "Safari";
  } else if (userAgent.includes("trident") || userAgent.includes("msie")) {
    return "Internet Explorer";
  } else {
    return "Unknown Browser";
  }
};

/**
 * Detects the operating system based on the platform property.
 *
 * @returns {string} The name of the operating system (e.g., 'Windows', 'Mac OS', 'Linux', 'iOS', 'Android', or 'Unknown OS').
 */
export const getOSName = () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (platform.includes("win")) {
    return "Windows";
  } else if (platform.includes("mac")) {
    return "Mac OS";
  } else if (platform.includes("linux")) {
    return "Linux";
  } else if (/iphone|ipad|ipod/.test(userAgent)) {
    return "iOS";
  } else if (/android/.test(userAgent)) {
    return "Android";
  } else {
    return "Unknown OS";
  }
};

/**
 * Formats start and end time with shift date into the required format.
 *
 * @param {string} startTime - Start time in "HH:mm" format.
 * @param {string} endTime - End time in "HH:mm" format.
 * @param {string} shiftDate - Shift date in "MM/dd/yyyy" format.
 * @returns {string} - Formatted date string like "12:25:00 PM, 29-01-2025 to 06:30:00 PM, 29-01-2025"
 */
export const formatShiftTime = (
  startTime,
  endTime,
  shiftDate,
  dateTimeFormat
) => {
  const DEFAULT_DATE_FORMAT = "hh:mm:ss a, MM/dd/yyyy";

  const finalFormat = dateTimeFormat || DEFAULT_DATE_FORMAT;

  const correctedFormat = finalFormat
    .replace(/DD/g, "dd")
    .replace(/YYYY/g, "yyyy")
    .replace(/YY/g, "yy")
    .replace(/hh/g, "hh")
    .replace(/HH/g, "HH")
    .replace(/A/g, "a")
    .trim();
  try {
    if (
      CommonUtil.isEmptyString(startTime) ||
      CommonUtil.isEmptyString(endTime) ||
      CommonUtil.isEmptyString(shiftDate)
    ) {
      return "-";
    }

    // Parse the shift date and times
    const parsedStart = parse(
      `${shiftDate} ${startTime}`,
      "MM/dd/yyyy HH:mm",
      new Date()
    );
    const parsedEnd = parse(
      `${shiftDate} ${endTime}`,
      "MM/dd/yyyy HH:mm",
      new Date()
    );

    // Validate parsed dates
    if (!isValid(parsedStart) || !isValid(parsedEnd)) {
      return "-";
    }

    // Format the times and date
    return `${format(parsedStart, correctedFormat)} to ${format(
      parsedEnd,
      correctedFormat
    )}`;
  } catch (error) {
    console.error("Error in formatShiftTime:", error.message);
    return "Invalid Date & Time formate";
  }
};

export const getFormattedLocalDate = (dateInMMS) => {
  if (!dateInMMS) return "";

  const activeLocale = getCurrentLocale();

  const formattedDateTime = formatInTimeZone(dateInMMS, "UTC", "MM-dd-yyyy hh:mm:ss a", { locale: activeLocale });
  return formattedDateTime;
};

/**
 * Validates and formats a date string. If the input is an invalid date, the current date is used instead.
 *
 * @param {string} inputDate - The input date string to validate and format.
 * @param {string} formatStr - The desired output format (e.g., 'MM/dd/yyyy').
 * @returns {string} - The formatted date string.
 */
export function formatDate(inputDate, formatStr = "MM/dd/yyyy") {
  const parsedDate = parseISO(inputDate);
  const finalDate = isValid(parsedDate) ? parsedDate : new Date();
  return format(finalDate, formatStr);
}

export const getApiLastTwoSegment = (apiUrl) => {
  if (CommonUtil.isEmptyString(apiUrl) || typeof apiUrl !== "string") {
    return "";
  }

  try {
    const urlObj = apiUrl.startsWith("https")
      ? new URL(apiUrl)
      : new URL("https/placeholder");
    const pathSegment = urlObj.pathname.split("/").filter(Boolean);
    if (pathSegment.length >= 2) {
      return `${pathSegment[pathSegment.length - 2]}/${
        pathSegment[pathSegment.length - 1]
      }`;
    }
    return pathSegment.length ? pathSegment[0] : "";
  } catch (error) {
    const cleanPath = apiUrl.split("?")[0];
    const segments = cleanPath.split("/").filter(Boolean);

    if (segments.length >= 2) {
      return `${segments[segments.length - 2]}/${
        segments[segments.length - 1]
      }`;
    }
    return segments.length ? segments[0] : "";
  }
};

export const readFromStorage = () => ({
  deviceTemplate: localStorage.getItem("virtualDeviceId") || "",
  companyCode: localStorage.getItem("companyCode") || "",
  employeeNumber: localStorage.getItem("employeeNumber") || "",
  uuid: localStorage.getItem("uuid") || "",
});

export const getFunctionKeyDetails = (menuIcon) => {
  const FUNCTION_KEYS = {
    clock_in: { eventCode: "0", action: "IN", label: "Clock In", src: clockIn },
    clock_out: {
      eventCode: "1",
      action: "OUT",
      label: "Clock Out",
      src: clockOut,
    },
    meal_start: {
      eventCode: "2",
      action: "OUT",
      label: "Meal Start",
      src: mealStart,
    },
    meal_end: { eventCode: "3", action: "IN", label: "Meal End", src: mealEnd },
    break_start: {
      eventCode: "4",
      action: "OUT",
      label: "Break Start",
      src: breakStart,
    },
    break_end: {
      eventCode: "5",
      action: "IN",
      label: "Break End",
      src: breakEnd,
    },
    department_transfer: {
      eventCode: "10",
      action: "IN",
      label: "Department Transfer (IN)",
      src: departmentImg,
    },
    meal_waive: {
      eventCode: "20",
      action: "OUT",
      label: "Meal Waive",
      src: waveMeal,
    },
    accrual_balance: {
      eventCode: "9",
      action: "IN",
      label: "Accrual",
      src: accrualBalance,
    },
    punch_info: {
      eventCode: "15",
      action: "IN",
      label: "Punch Info",
      src: punchInfo,
    },
    clock_in_3: {
      eventCode: "40",
      action: "IN",
      label: "Exempt Check In",
      src: clockIn3,
    },
    online_schedule: {
      eventCode: "14",
      action: "IN",
      label: "Online Schedule",
      src: onlineSchedule,
    },
  };

  return FUNCTION_KEYS[menuIcon];
};

/**
 * @function getDateTimeInMs
 * @description Fetches UTC time from the server and returns it in epoch milliseconds.
 * If the API call fails, falls back to the local system time.
 * @returns { Promise < number >} Epoch time in milliseconds.
 */

export const getDateTimeInMs = async () => {
  
  try {
    const res = await getServerUtcTime();
    const serverTime = res?.data?.time;
    return serverTime ? new Date(serverTime).getTime() : Date.now();
  } catch (error) {
    console.error("Error fetching server UTC time:", error);
    return Date.now();
  }
};

export const getSourceMeta = () => ({
  appVersion: packageJson.version,
  sourceID: localStorage?.getItem("terminal"),
  mode: localStorage.getItem("accountType"),
});

export const getLastPunchData = async () => {
  try {
    const res = await getLastPunch();
    if (res?.data && !CommonUtil.isEmpty(res.data)) {
      return res.data;
    }
    return {};
  } catch (error) {
    console.error(
      "Error while fetching the employee's last punch data:",
      error
    );
    return {};
  }
};

/**
 * Checks if a specific rule is enabled within the menu object.
 * @param {Object} menuObj - The menu object containing rules.
 * @param {string} ruleName - The rule name to check for.
 * @returns {boolean} True if the rule is enabled, otherwise false.
 */
export const isRuleEnabled = (menuObj, ruleName) => {
  if (!menuObj || !Array.isArray(menuObj?.rules)) return false;
  return menuObj.rules.includes(ruleName);
};

/**
 * Determines if a punch event is considered a duplicate based on lockout rules.
 * @param {string|number} currentEventCode - The event code of the current punch.
 * @param {number} currentTime - Current punch timestamp in milliseconds(utc).
 * @param {number} consecutivePunchLockoutPeriod - Lockout duration in seconds.
 * @param {string} lockoutFor - Lockout rule type (e.g. SAME_EVENT_CODE, ANY_EVENT_CODE, SAME_EVENT_TYPE).
 * @param {object} lastPunch - The last punch object containing eventCode and punchDate.
 * @returns {boolean} True if within lockout period and matching criteria; otherwise false.
 */
export const isDuplicatePunch = (
  currentEventCode,
  currentTime,
  consecutivePunchLockoutPeriod,
  lockoutFor,
  lastPunch
) => {
  if (
    !currentTime ||
    !lastPunch?.punchDate ||
    !consecutivePunchLockoutPeriod
  ) {
    return false;
  }

  const { eventCode = "", punchDate = 0 } = lastPunch;
  const currentCode = String(currentEventCode);
  const lastCode = String(eventCode);
  const checkConsecutivePunchFor = String(lockoutFor);

  const isWithinLockoutPeriod = () => {
    const consecutivePunchLockoutEnd = toZonedTime(
      punchDate + consecutivePunchLockoutPeriod * 1000
    );
    return isBefore(new Date(), consecutivePunchLockoutEnd);
  };

  if (
    checkConsecutivePunchFor === AppConstant.ANY_EVENT_CODE &&
    AppConstant.ANY_EVENT_CODE_LIST.includes(currentCode)
  ) {
    return isWithinLockoutPeriod();
  }

  if (
    checkConsecutivePunchFor === AppConstant.SAME_EVENT_CODE &&
    currentCode === lastCode
  ) {
    return isWithinLockoutPeriod();
  }

  if (checkConsecutivePunchFor === AppConstant.SAME_EVENT_TYPE) {
    const sameTypeEventCodes = AppConstant.SAME_EVENT_TYPE_IN.includes(lastCode)
      ? AppConstant.SAME_EVENT_TYPE_IN
      : AppConstant.SAME_EVENT_TYPE_OUT.includes(lastCode)
      ? AppConstant.SAME_EVENT_TYPE_OUT
      : [];

    if (sameTypeEventCodes.includes(currentCode)) {
      return isWithinLockoutPeriod();
    }
  }

  return false;
};

export const getDurationText = (totalSeconds) => {
  if (!totalSeconds || isNaN(totalSeconds) || totalSeconds < 0) return "0 Seconds";

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const minuteLabel = minutes === 1 ? "Minute" : "Minutes";
  const secondLabel = seconds === 1 ? "Second" : "Seconds";

  if (minutes > 0 && seconds > 0) {
    return `${minutes} ${minuteLabel}, ${seconds} ${secondLabel}`;
  } else if (minutes > 0) {
    return `${minutes} ${minuteLabel}`;
  } else {
    return `${seconds} ${secondLabel}`;
  }
};
